const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/user/logout/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/user/logout/')({
  staticData: {
    breadCrumb: 'Logout'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});